import api from './api';
import './App.css';
import { Login } from './Login/Login.jsx';
import React, { useEffect, useState } from 'react';
import MainApp from './MainApp';
import { ThemeProvider } from '@emotion/react';
import theme from './styles/theme';
import EmployeePunch from './TimeManager/EmployeePunch';


import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import moment from 'moment';
import 'moment/locale/fr';
import { Backdrop, CircularProgress, responsiveFontSizes } from '@mui/material';
import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';


moment.locale('fr')

let theme2 = responsiveFontSizes(theme);
theme2.typography.h1 = {
  "fontFamily": "\"Raleway\", sans-serif",
  "fontWeight": 300,
  "fontSize": "2.25rem",
  "lineHeight": 1.167,
  "letterSpacing": "-0.01562em",
  "@media (min-width:600px)": {
    "fontSize": "2.7849rem"
  },
  "@media (min-width:900px)": {
    "fontSize": "3.2134rem"
  },
  "@media (min-width:1200px)": {
    "fontSize": "3.4276rem"
  }
};

theme2.typography.h2 = {
  ...theme2.typography.h2,
  "fontFamily": "\"Raleway\", sans-serif",
};

theme2.typography.h3 = {
  ...theme2.typography.h3,
  "fontFamily": "\"Raleway\", sans-serif",
};

theme2.typography.h4 = {
  ...theme2.typography.h4,
  "fontFamily": "\"Raleway\", sans-serif",
};

theme2.typography.h5 = {
  ...theme2.typography.h5,
  "fontFamily": "\"Raleway\", sans-serif",
};

theme2.typography.h6 = {
  ...theme2.typography.h6,
  "fontFamily": "\"Raleway\", sans-serif",
};

theme2.typography.subtitle1 = {
  ...theme2.typography.subtitle1,
  "fontFamily": "\"Raleway\", sans-serif",
};

theme2.typography.subtitle2 = {
  ...theme2.typography.subtitle2,
  "fontFamily": "\"Raleway\", sans-serif",
};

theme2.typography.body1 = {
  ...theme2.typography.body1,
  "fontFamily": "\"Raleway\", sans-serif",
};

theme2.typography.body2 = {
  ...theme2.typography.body2,
  "fontFamily": "\"Raleway\", sans-serif",
};


const App = (props) => {
  let [token, setToken] = useState(localStorage.getItem("accessToken"))
  let [isConnected, setIsConnected] = useState(null)
  let [isAdmin, setIsAdmin] = useState(null)
  const queryClient = new QueryClient()

  useEffect(() => {
    verifyAuth()
  }, [])

  useEffect(() => {
    getIsAdmin()
  }, [token, isConnected])


  const verifyAuth = async () => {
    let storedToken = localStorage.getItem("accessToken");

    if (storedToken) {
      let res = await api.post('/token/verify/', { 'token': storedToken })

      if (res.status === 200) {
        if (!token) {
          setToken(storedToken)
        }
        setIsConnected(true)
        getIsAdmin()
        return
      }
    }
    setIsConnected(false)

  }

  const getIsAdmin = async () => {
    if (!token) {
      setIsAdmin(null)
      return
    }
    
    let res = await api.get('/is_admin/')
    setIsAdmin(res.data)
  }

  console.log(isConnected, isAdmin)

  if (isConnected === null || (isAdmin === null && isConnected)) {
    return (
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={true}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    )
  }

  if (isConnected) {
    if (isAdmin) {
      return (
        <ThemeProvider theme={theme2}>
          <QueryClientProvider client={queryClient}>
            <MainApp />
          </QueryClientProvider>
        </ThemeProvider>
      )
    }
    else {
      return (
        <ThemeProvider theme={theme2}>
          <QueryClientProvider client={queryClient}>
            <main className="wrapper">
              <EmployeePunch />
            </main>
          </QueryClientProvider>
        </ThemeProvider>
      )
    }
  }


  return (
    <ThemeProvider theme={theme}>
      <Login verifyAuth={verifyAuth} ></Login>
    </ThemeProvider>
  )
}

export default App;
